import { ReactElement } from 'react';
import Lang from '@lang/en';
import { OrdersStateTypes } from '../../ordersTable/types';
import DataTile from './dataTile';
import { StatsI } from '../types';

type DataTilesI = {
  stats: StatsI;
  isActive: (ordersType: OrdersStateTypes) => boolean;
  ordersStateChange: (ordersState: OrdersStateTypes) => void;
};

const DataTiles = ({
  stats,
  isActive,
  ordersStateChange,
}: DataTilesI): ReactElement => {
  return (
    <>
      <DataTile
        name="ordered"
        label={Lang.healthCheckFilterBarOrderedText}
        value={stats.ordered || 0}
        active={isActive('ordered')}
        onClick={() => ordersStateChange('ordered')}
      />
      <DataTile
        name="confirmed"
        label={Lang.healthCheckFilterBarConfirmedText}
        value={stats.confirmed || 0}
        active={isActive('confirmed')}
        onClick={() => ordersStateChange('confirmed')}
      />
      <DataTile
        name="pending"
        label={Lang.healthCheckFilterBarWaitingForAntigenResultsText}
        value={stats.pending || 0}
        active={isActive('pending')}
        onClick={() => ordersStateChange('pending')}
      />
      <DataTile
        name="done"
        label={Lang.healthCheckFilterBarTestedText}
        value={stats.done || 0}
        active={isActive('done')}
        onClick={() => ordersStateChange('done')}
      />
    </>
  );
};

export default DataTiles;
